import moment from "moment";

const formatData = function(type, value, mod) {
    if (type == 'date') {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
    } 
    else if (type == 'datetimetext') {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
    } 
    else if (type == 'datepicker'){
        return moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
    }
    else if (type == 'datetime'){
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    }
    else if (type == 'number') {
        if (!isNaN(value)) {
            return parseFloat(value).toFixed(2);
        }
        else{
            return '';
        }
    }
    else if( type == 'chart' ){
        let unit = '';
        if( (value / 1000000) > 1 ){
            value = parseFloat((value / 1000000)).toFixed(1);
            unit = 'M';
        }
        if( (value / 1000) > 1 ){
            value = parseFloat((value / 1000)).toFixed(1);
            unit = 'K';
        }
        else{
            let digit = 0;
            if( mod == 'totalWeightLoss' || mod == 'preTest' || mod == 'postTest' ){
                digit = 1;
                if( mod == 'preTest' || mod == 'postTest' ){
                    unit = '%';
                }
            }
            else if (mod == 'onsite' ){
                digit = 2;
            }
            value = parseFloat(Math.ceil((value*10))/10).toFixed(digit);
        }
        value = value + unit;
    }
    else if (type == 'capitalize') {
        return value[0].toUpperCase() + value.slice(1);
    }
    else if (type == 'trucatedText' ){
        return value.length > 180 ? value.substring(0, 180) + '...' : value;
    }
    else if (type == 'average') {
        return value.toString().split('.')[1]?.length > 2 ? parseFloat(value).toFixed(2) : value;
    }
    return value;
};

export default formatData;